import React, { useState, useEffect } from "react";
import Layout1 from "../../components/layout1";
import Calender from "./calender";
import SubHeader from "../../components/subHeader";
import "./index.css";
import { IoIosList } from "react-icons/io";
import ListViewCalender from "./calender/listViewCalendar";
import { LuCalendarDays } from "react-icons/lu";
import { Pagination } from "antd";
import { appointmentList } from "../../functions/appointments";
import { loaderReducer } from "../../components/toolkit/loader";
import { useDispatch } from "react-redux";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import { CalenderList } from "../../functions/appointments";
import format from "date-fns/format";

const Index = () => {
  const [view, setView] = useState(false);
  const [month, setMonth] = useState("");
  const [calenderMonth, setCalenderMonth] = useState(
    format(new Date(), "MM-yyyy")
  );
  const [appointmentData, setAppointmentData] = useState([]);
  const [calenderData, setCalenderData] = useState([]);
  const [totalData, setTotalData] = useState(1);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();

  const cookies = new Cookies();
  const authtoken = cookies.get("token");

  const handleView = () => {
    setView(!view);
  };

  //List view data -----------------------------------------------------
  const fetchcalenderData = async () => {
    dispatch(loaderReducer(true));
    try {
      await appointmentList(authtoken, month, page)
        .then((res) => {
          dispatch(loaderReducer(false));
          setAppointmentData(res.data.data.appointmentList);
          setTotalData(res.data.data.appointmentList.length);
        
        })
        .catch((err) => {
          dispatch(loaderReducer(false));
          toast.error(err);
        });
    } catch (error) {
      dispatch(loaderReducer(false));
      // console.log(error);
      toast.error(error);
    }
  };

  useEffect(() => {
    setPage(1);
  }, [month]);

  useEffect(() => {
    fetchcalenderData();
  }, [month, page]);

  //Calender view Data ------------------------------------------------------------------------
  const fetchCalenderViewData = async () => {
    dispatch(loaderReducer(true));
    try {
      await CalenderList(authtoken, calenderMonth)
        .then((res) => {
          dispatch(loaderReducer(false));
          setCalenderData(res.data.data.appointmentList);
       
        })
        .catch((err) => {
          dispatch(loaderReducer(false));
          console.log(err);
          toast.error(err.response.data.message || err.message);
        });
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error);
    }
  };

  useEffect(() => {
    fetchCalenderViewData();
  }, [calenderMonth]);

  // console.log("..", calenderMonth);
  return (
    <Layout1>
      <SubHeader />
      <div className="mt-4">
        <div
          className="calendercls"
          style={{ justifyContent: "space-between", display: "flex" }}
        >
          <div className="tupdate mt-2">Appointments Calendar</div>
          <div
            className="mt-2"
            onClick={handleView}
            style={{ cursor: "pointer" }}
          >
            {view ? (
              <div>
                <LuCalendarDays />{" "}
                <span className="textClss">Switch to Calendar View</span>
              </div>
            ) : (
              <div>
                <IoIosList />{" "}
                <span className="textClss">Switch to List View</span>
              </div>
            )}
          </div>
        </div>
        
        <div className="calendercls">
          <div className="calendercls1">
            {view ? (
              <div style={{ padding: "15px" }}>
                <ListViewCalender
                  arg={{ month, setMonth, appointmentData, setAppointmentData }}
                />
              </div>
            ) : (
              <Calender
                arg={{
                  calenderMonth,
                  setCalenderMonth,
                  calenderData,
                  setCalenderData,
                }}
              />
            )}
          </div>
          {view && (
            <div className="mt-3 d-flex justify-content-end">
              <Pagination
                total={totalData}
                showQuickJumper
                showTotal={(total) => `Total ${total} items`}
                showSizeChanger={false}
                onChange={(page) => setPage(page)}
              />
            </div>
          )}
        </div>
      </div>
    </Layout1>
  );
};

export default Index;
